module.exports = __webpack_public_path__ + "img/only-blue-bg.e0c3752.png";